import { Link } from "react-router-dom";
import { useContext } from "react";
import { DataContext } from "../DataProvider";
const Logo = () => {
    const logoStyle = {
        color: "#fff",
        fontFamily: "'Libre Franklin', sans-serif"
    }

    const { setHtml, setCss, setJs } = useContext(DataContext);

    const handleClick = () => {
        setHtml(`




`);
        setCss(`




`);
        setJs(`




`);
    }

    return (
        <Link to="/" onClick={handleClick}>
            <h1 style={logoStyle}>CodeMirror</h1>
        </Link>
    );
}

export default Logo;